var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-right-cmp"},[_c('dv-charts',{staticStyle:{"width":"100%","height":"500px"},attrs:{"option":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }